module.exports = __webpack_public_path__ + "static/media/elixir-brochur-img-1.f5143ca0.jpg";